import React, { useEffect, useContext } from 'react';
import ServerContext from '../../../contexts/serverContext';
import { CategoriesProps } from '../browse-by-topic/hook/use-bbt-content';
import './bbt-categories.scss';
import { CategoryPage } from '../../models/category-page';
import { BRAND } from '../../../constants';

interface Props {
    category: string;
    subcategory?: string;
    categories?: CategoryPage[] | null;
    filteredCategories?: CategoryPage | null;
    bbtContent: CategoriesProps | null;
}

const BbtCategories = (props: Props) => {
    const serverContext = useContext(ServerContext);
    const aemBaseUrl = process.env.REACT_APP_AEM_BASE_URL;
    const currentRoot = serverContext.root
        ? serverContext.root.substring(0, serverContext.root.length - 1)
        : '';
    const defaultIconPathActive =
        serverContext.brand === BRAND.ford.LONG_NAME
            ? 'icons/bbt-default-side-nav-active.svg'
            : 'icons/bbt-default-side-nav-active-lincoln.svg';
    const defaultIconPathNotActive =
        serverContext.brand === BRAND.ford.LONG_NAME
            ? 'icons/bbt-default-side-nav-not-active.svg'
            : 'icons/bbt-default-side-nav-not-active-lincoln.svg';
    useEffect(() => {
        if (props.subcategory) {
            const click = document.getElementById(
                props.category
            ) as HTMLUListElement;
            if (click) click.style.display = 'block';
        }
    }, []);

    return (
        <div className="left-panel">
            <nav>
                <ul className="categories">
                    {props.categories &&
                        props.categories?.map(categ => {
                            const matchingCategory =
                                props.bbtContent &&
                                props.bbtContent.categories?.find(
                                    cat =>
                                        parseInt(cat.category) ===
                                        categ.categoryId
                                );
                            const activeCategorySideIconAemBaseUrl = matchingCategory?.activeCategorySideIcon
                                ? aemBaseUrl?.concat(
                                      matchingCategory?.activeCategorySideIcon
                                  )
                                : defaultIconPathActive;
                            const inactiveCategorySideIconAemBaseUrl = matchingCategory?.inactiveCategorySideIcon
                                ? aemBaseUrl?.concat(
                                      matchingCategory?.inactiveCategorySideIcon
                                  )
                                : defaultIconPathNotActive;
                            const iconPath =
                                categ.categoryId ===
                                props.filteredCategories?.categoryId
                                    ? activeCategorySideIconAemBaseUrl
                                    : inactiveCategorySideIconAemBaseUrl;
                            return (
                                <li
                                    className="categories-list"
                                    key={categ.categoryId}
                                >
                                    <a
                                        className={`category-link ${
                                            props.category === categ.categorySeo
                                                ? 'active'
                                                : ''
                                        }`}
                                        href={`${currentRoot}${categ.categoryAbsoluteSeo}`}
                                    >
                                        <img
                                            src={iconPath}
                                            alt=""
                                            className="category-icon"
                                        ></img>
                                        <p className="category-name">
                                            {categ.categoryName}
                                        </p>
                                    </a>
                                    <ul
                                        id={categ.categorySeo}
                                        className="left-subcategories"
                                    >
                                        {categ.subCategories.map(
                                            (subCateg, index) => {
                                                return (
                                                    subCateg.allTopics &&
                                                    subCateg.allTopics.length >
                                                        0 && (
                                                        <li
                                                            className="left-subcategories-list"
                                                            key={index}
                                                        >
                                                            <a
                                                                className={`subcategory-link ${
                                                                    props.subcategory ===
                                                                    subCateg.subCategorySeo
                                                                        ? 'active'
                                                                        : ''
                                                                }`}
                                                                href={`${currentRoot}${subCateg.subCategoryAbsoluteSeo}`}
                                                            >
                                                                <span className="subcategory-name">{`${subCateg.subCategoryName}`}</span>
                                                                <span className="topics-length">{`(${subCateg.allTopics.length})`}</span>
                                                            </a>
                                                        </li>
                                                    )
                                                );
                                            }
                                        )}
                                    </ul>
                                </li>
                            );
                        })}
                </ul>
            </nav>
        </div>
    );
};
export default BbtCategories;
